export const HISTORY_REQUEST = 'HISTORY_REQUEST';
export const HISTORY_SUCCESS = 'HISTORY_SUCCESS';
export const HISTORY_FAIL = 'HISTORY_FAIL';

export function historyRequest(rowsPerPage,page,search) {
    return {
        type: HISTORY_REQUEST,
        payload: {rowsPerPage,page,search },
    };
}

export const HISTORY_FILTER = 'HISTORY_FILTER';

export function historyFilterRec(data) {
    return {
        type: HISTORY_FILTER,
        payload: {data},
    };
}

export const HISTORY_COMPLETED = 'HISTORY_COMPLETED';

export function historyCompleted(data) {
    return {
        type: HISTORY_COMPLETED,
        payload: {data},
    };
}


export const HISTORY_EXEL_REQUEST = 'HISTORY_EXEL_REQUEST';
export const HISTORY_EXEL_SUCCESS = 'HISTORY_EXEL_SUCCESS';
export const HISTORY_EXEL_FAIL = 'HISTORY_EXEL_FAIL';

export function historyExelRequest(rowsPerPage,page,search) {
    return {
        type: HISTORY_EXEL_REQUEST,
        payload: {rowsPerPage,page,search },
    };
}
